module.exports = __webpack_public_path__ + "img/full2-min.6e8b47a6.png";